<template>
  <div>
    <div class="card-body pb-0" v-if="errors.length">
        <base-alert  type="danger" class="mb-0">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
    </div>
    <h2>Setup product for Shopee
        <div class="float-right">
            <a-button type="primary" class="btn btn-primary float-right btn-sm border-sm mr-0" v-if="this.$attrs.actionStatus=='Edit'" :loading="saveLoading" @click.prevent="updateParams">Update</a-button>
            <a-button type="primary" class="btn btn-primary float-right btn-sm border-sm mr-0" v-else-if="this.$attrs.actionStatus!='Edit'" :loading="saveLoading" @click.prevent="saveParams">Save</a-button>
            <a-button type="primary" class="btn float-right mr-0 bg-white text-dark mr-3 btn-sm" @click.prevent="$emit('closeProductFrom', null)">Cancel</a-button>
        </div>
    </h2>
    <div class="row mt-4 overflow-auto" style="height: 44rem;">
        <div class="col-md-12">
            <a-collapse v-model="activeKey" expand-icon-position="right" class="border-0 bg-white">
                <a-collapse-panel key="1" header="01. Basic Information" :style="customStyle">
                    <base-input v-model="shopeeTemplate.name" input-classes="form-control form-control-sm" label="Product Name" required />
                    <div class="form-group has-label"><label class="form-control-label">
                        Description<span>*</span></label>
                        <textarea rows="4" class="form-control" v-model="shopeeTemplate.description"/>
                    </div>
                    <div class="form-group has-label"><label class="form-control-label">
                        Select Category<span>*</span></label>
                        <a-cascader
                            :field-names="{ label: 'category_name', value: 'category_id', children: 'children', isLeaf: 'has_children' }"
                            :options="categories"
                            placeholder="Please select category"
                            :show-search="{ filter }"
                            @change="onChangeCategory"
                            v-model="shopeeTemplate.cascader_category"
                        />
                    </div>
                    <div class="row" v-if="shopeeTemplate.cascader_category.length>=1">
                        <div class="col-md-4" v-for="(att,index) in shopeeTemplate.attributes" v-if="((productDetails.product_type=='M' && att.attribute_name!='Color' && att.attribute_name!='Size') || (productDetails.product_type!='M')) && att.attribute_name!='Weight'">
                            <base-input v-if="att.input_type!='COMBO_BOX' && att.input_type!='DROP_DOWN' && att.attribute_type!='INT_TYPE' && att.attribute_type!='DATE_TYPE'" v-model="shopeeTemplate.attribute_values[`${att.attribute_id}`]" :value="shopeeTemplate.attribute_values[`${att.attribute_id}`]!=null? shopeeTemplate.attribute_values[`${att.attribute_id}`] = shopeeTemplate.attribute_values[`${att.attribute_id}`] : shopeeTemplate.attribute_values[`${att.attribute_id}`] = null" input-classes="form-control form-control-sm" :label="att.attribute_name" :required="att.is_mandatory"/>
                            <base-input v-if="att.attribute_type=='INT_TYPE' && att.input_type == 'TEXT_FILED'" v-model="shopeeTemplate.attribute_values[`${att.attribute_id}`]" min="0" type="number" :value="shopeeTemplate.attribute_values[`${att.attribute_id}`]!=null? shopeeTemplate.attribute_values[`${att.attribute_id}`] = shopeeTemplate.attribute_values[`${att.attribute_id}`] : shopeeTemplate.attribute_values[`${att.attribute_id}`] = null" input-classes="form-control form-control-sm" :label="att.attribute_name" :required="att.is_mandatory"/>
                            <base-input v-if="att.attribute_type=='DATE_TYPE'" v-model="shopeeTemplate.attribute_values[`${att.attribute_id}`]" type="date" :value="shopeeTemplate.attribute_values[`${att.attribute_id}`]!=null? shopeeTemplate.attribute_values[`${att.attribute_id}`] = shopeeTemplate.attribute_values[`${att.attribute_id}`] : shopeeTemplate.attribute_values[`${att.attribute_id}`] = null" input-classes="form-control form-control-sm" :label="att.attribute_name" :required="att.is_mandatory"/>
                            <div class="form-group has-label" v-else-if="att.input_type=='COMBO_BOX' || att.input_type=='DROP_DOWN'">
                             <label class="form-control-label">
                                {{att.attribute_name}}<span v-if="att.is_mandatory">*</span></label>
                                <a-select 
                                v-model="shopeeTemplate.attribute_values[`${att.attribute_id}`]"
                                show-search
                                :placeholder="'Select ' + att.attribute_name">
                                    <a-select-option v-for="data in att.options" v-bind:key="data" :value="data" >{{data}}
                                    </a-select-option>
                                </a-select>
                            </div>
                        </div>
                    </div>
                </a-collapse-panel>
                <a-collapse-panel key="2" header="02. Sales Information"  :style="customStyle">
                    <div class="row" v-if="productDetails.product_type !='M'">
                        <div class="col-md-3 p-1 pl-3">
                            <base-input v-model="shopeeTemplate.price" input-classes="form-control form-control-sm" min="1" step="0.01" type="number" label="Price" required/>
                        </div>
                        <div class="col-md-3 p-1">
                            <base-input v-model="shopeeTemplate.stock" input-classes="form-control form-control-sm" min="0" type="number" label="Stock" required disabled/>
                        </div>
                        <div class="col-md-3 p-1">
                            <base-input v-model="shopeeTemplate.item_sku"  input-classes="form-control form-control-sm" label="Parent Sku" required/>
                        </div>
                    </div>
                    <div class="row" v-if="productDetails.product_type =='M'">
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered mb-0 w-100">
                                    <thead>
                                        <tr>
                                            <th v-if="shopeeTemplate.is_2tier_item == true && shopeeTemplate.tier_variation.length > 0" v-for="(data,index) in shopeeTemplate.tier_variation" v-bind:key="index">{{data.name}}</th>
                                            <th v-if="shopeeTemplate.is_2tier_item == false"></th>
                                            <th>Price</th>
                                            <th>Stock</th>
                                            <th>SKU</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(subProduct,subProductIndex) in shopeeTemplate.temp_variation" v-bind:key="subProductIndex">
                                            <td v-if="subProduct.option!=null">
                                                {{subProduct.option}}
                                            </td>
                                            <td v-if="subProduct.option1!=null">
                                                {{subProduct.option1}}
                                            </td>
                                            <td><base-input min="1" type="number"  v-model="shopeeTemplate.variation[subProductIndex].price" input-classes="form-control form-control-sm" required /></td>
                                            <td><base-input min="0" max="5000" type="number" v-model="shopeeTemplate.variation[subProductIndex].stock" input-classes="form-control form-control-sm" required disabled/></td>
                                            <td><base-input v-model="shopeeTemplate.variation[subProductIndex].variation_sku" input-classes="form-control form-control-sm" required /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </a-collapse-panel>
                <a-collapse-panel key="3" header="03. Shipping" :style="customStyle">
                    <div class="row">
                        <div class="col p-1 pl-3">
                            <base-input v-model="shopeeTemplate.weight" input-classes="form-control form-control-sm" min="0.01" step="0.01" type="number" label="Weight (kg)" required/>
                        </div>
                        <div class="col p-1">
                            <base-input v-model="shopeeTemplate.package_height" input-classes="form-control form-control-sm" min="0" type="number" label="Height (cm)" required/>
                        </div>
                        <div class="col p-1">
                            <base-input v-model="shopeeTemplate.package_width" input-classes="form-control form-control-sm" min="0" type="number" label="Width (cm)" required/>
                        </div>
                        <div class="col p-1 pr-3">
                            <base-input v-model="shopeeTemplate.package_length" input-classes="form-control form-control-sm" min="0" type="number" label="Length (cm)" required/>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <div class="row">
                            <div class="col-md-12">
                                <label class="label mb-0"><span class="text-danger h4 align-middle mb-0">*</span><small>Shipping fee</small></label>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th class="text-uppercase line-spacing01 p-2">Shipping provider</th>
                                            <th class="text-uppercase line-spacing01 p-2">Weight</th>
                                            <th class="text-uppercase line-spacing01 p-2">Shipping fee</th>
                                            <th class="text-uppercase line-spacing01 p-2">enabled</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data,key) in logistics" v-if="data.enabled == true">
                                            <td>{{data.logistic_name}}</td>
                                            <td>(<span v-if="data.weight_limits.item_min_weight>0">min {{data.weight_limits.item_min_weight}} kg,</span><span>max {{data.weight_limits.item_max_weight}} kg</span>)</td>
                                            <td>
                                                <div :value="data.size_value !=null? data.size_value=data.size_value : data.size_value='1'" hidden></div>
                                                <label v-if="data.sizes.length>0" class="mb-0">
                                                    <select class="form-control form-control-sm" v-model="data.size_value" id="exampleFormControlSelect1">
                                                        <option v-for="s in data.sizes" :value="s.size_id" v-bind:key="s.size_id">{{s.default_price}}</option>
                                                    </select>
                                                </label>
                                            </td>
                                            <td align="center">
                                                <a-switch :id="key" v-model="data.value" @click="onClickLogistics(logistics[key].value,data.logistic_id,data.logistic_name,data.size_value)" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </a-collapse-panel>
            </a-collapse>
        </div>
    </div>
  </div>
</template>
<script>
    import axios from "axios";
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import Quill from 'quill'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType','publicUrl']),
        },
        mounted: async function(){
            component_x = this
            this.imageUrl = this.publicUrl + 'product_images'
            this.accessToken = this.$attrs.ShopeeAccessToken
            var arr = this.$attrs.productIntegrationData
            this.salesChannelId = this.$attrs.salesChannelId
            await this.getCategories()
            if (this.$attrs.actionStatus == "Edit"){
                this.productDetails = arr
                this.shopeeTemplate = arr.shopeeParams
                console.log(arr["category_cascader"].length)
                if(arr["category_cascader"].length<=1){
                    this.tempCascaderCategory = []
                    this.getParentCategory(arr["category_cascader"][0])
                }
                this.getAttributes(true)
                this.getLogistics(true)
            }else {
                if (arr.product_type == "M"){
                    var response = await HTTPRequest.getRequest(this.endPoint + 'marketplace_integrations/get_sub_product_details?id='+arr.id+'&site_id='+this.$attrs.siteId+'&sublocation_id='+this.$attrs.selectedSublocationId+'&percent='+this.$attrs.inventoryPercentage, null)
                    arr.sub_products = response
                    this.productDetails = arr
                    this.getVariationBaseOnSelectedCategory()
                }else {
                    this.shopeeTemplate.item_sku = arr.stock_no
                    this.shopeeTemplate.price = arr.retail_price
                    this.productDetails = arr
                    this.getProductAvailableQuantity(arr.id)
                }
                this.shopeeTemplate.name = arr.name
                this.shopeeTemplate.weight = arr.weight
                this.shopeeTemplate.package_height = arr.height
                this.shopeeTemplate.package_width = arr.width
                this.shopeeTemplate.package_length = arr.length
                this.getLogistics()
            }
        },
        data(){
            return {
                accessToken:null,
                saveLoading:false,
                categories:[],
                tempCategories:[],
                tempCascaderCategory:[],
                imageUrl:null,
                errors:[],
                activeKey:['1','2','3','4'],
                customStyle:"margin-bottom: 24px;border: 1px solid #dee2e6!important;background-color: #fafafa;",
                logistics:[],
                fetching:false,
                productDetails:[],
                sizeAttributeIndex:-1,
                ColorAttributeIndex:-1,
                shopeeTemplate:{
                    category_id:null,
                    attributes:[],
                    attribute_values:{},
                    tier_variation:[],
                    variation:[],
                    temp_variation:[],
                    logistics:[],
                    tempLogistics:[],
                    name:null,
                    description:null,
                    stock:0,
                    price:null,
                    item_sku:null,
                    package_length:null,
                    package_height:null,
                    weight:null,
                    package_width:null,
                    cascader_category:[],
                },
                salesChannelId:null,
            }
        },
        methods: {
            getCategories: async function(){
                var response = await HTTPRequest.postRequest(this.endPoint+ 'shopee_integrations/categories', null, {access_token:this.accessToken})
                if (response["error"] == undefined){
                    var arr = []
                    this.tempCategories = response["categories"]
                    for (var i = response["categories"].length-1; i >= 0; i--) {
                        var data = response["categories"][i]
                        var parent_index = response["categories"].findIndex(x => x.category_id == data.parent_id)
                        if (parent_index>=0){
                            var parentData = response["categories"][parent_index]
                            if (parentData["children"]==undefined){
                                parentData["children"] = []
                            }
                            parentData["children"].push(data)
                        }else{
                            arr.push(data)
                        }
                    }
                    this.categories = arr
                }else {
                    this.errors = response["error"].split(",")
                }
            },
            onChangeCategory(value){
                this.getAttributes()
            },
            filter(inputValue, path) {
                return (path.some(option => (option.category_name).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
            },
            getAttributes: async function(status){
                if (this.shopeeTemplate.cascader_category.length >0){
                    this.shopeeTemplate.category_id = this.shopeeTemplate.cascader_category[this.shopeeTemplate.cascader_category.length - 1]
                    var response = await HTTPRequest.postRequest(this.endPoint+ 'shopee_integrations/attributes', null, {access_token:this.accessToken,category_id:this.shopeeTemplate.cascader_category[this.shopeeTemplate.cascader_category.length - 1]})
                    if (response["error"] == undefined){
                        this.shopeeTemplate.attributes = response["attributes"]
                        if(status==undefined){
                            this.shopeeTemplate.attribute_values = {}
                        }
                    }else {
                        this.errors = response["error"].split(",")
                    }
                }
            },
            getLogistics: async function(status){
                var response = await HTTPRequest.postRequest(this.endPoint+ 'shopee_integrations/logistics', null, {access_token:this.accessToken})
                if (response["error"] == undefined){
                    this.logistics = response
                    if (status){
                        this.shopeeTemplate.logistics.forEach((value, index) => {
                            var index = this.logistics.findIndex(x => x.logistic_id === value.logistic_id)
                            if (index>=0){
                                this.logistics[index].value = true
                            }
                        })
                    }
                }else {
                    this.errors = response["error"].split(",")
                }
            },
            onClickLogistics(value, logistic_id, logistic_name, size){
                if (value) {
                    var index =  this.shopeeTemplate.logistics.findIndex(x => x.logistic_id === logistic_id)
                    if (index == -1) {
                        if (size == null || size == '') {
                            this.shopeeTemplate.tempLogistics.push({ logistic_id: logistic_id,logistic_name:logistic_name, enabled: true })
                            this.shopeeTemplate.logistics.push({ logistic_id: logistic_id, enabled: true })
                        } else {
                            this.shopeeTemplate.tempLogistics.push({ logistic_id: logistic_id,logistic_name:logistic_name, enabled: true, size_id: Number(size) })
                            this.shopeeTemplate.logistics.push({ logistic_id: logistic_id, enabled: true, size_id: Number(size) })
                        }
                    }
                } else {
                    this.shopeeTemplate.tempLogistics.splice(index, 1)
                    this.shopeeTemplate.logistics.splice(index, 1)
                }
            },
            getProductAvailableQuantity: async function(id){
                var response = await HTTPRequest.getRequest(this.endPoint+ 'marketplace_integrations/get_product_stock?id='+id+'&site_id='+this.$attrs.siteId+'&sublocation_id='+this.$attrs.selectedSublocationId, null)
                console.log(response.available_quantity)
                if (response!=null){
                    if (response["error"] == undefined){
                        this.shopeeTemplate.stock = (response.available_quantity*this.$attrs.inventoryPercentage)/100
                        this.shopeeTemplate.stock  = this.shopeeTemplate.stock<0 ? 0 : this.shopeeTemplate.stock
                    }else {
                        this.shopeeTemplate.stock = 0
                    }
                }else{
                    this.shopeeTemplate.stock = 0
                }
            },
            getVariationBaseOnSelectedCategory(status){
                if (status == undefined){
                    this.shopeeTemplate.variation = []
                    this.shopeeTemplate.tier_variation = []
                    this.shopeeTemplate.temp_variation = []
                    var tier_count = 0
                    var color_status = false
                    var size_status = false
                    var design_status = false
                    var color_index = -1
                    var size_index = -1
                    var design_index = -1
                    this.productDetails.sub_products.forEach((value, index) => {
                        if (index == 0){
                            if (value.color_name!=null){
                                tier_count = tier_count+1
                                color_status = true
                            }
                            if (value.size_name!=null){
                                tier_count = tier_count+1
                                size_status = true
                            }
                            if (value.design_name!=null){
                                tier_count = tier_count+1
                                design_status = true
                            }
                        }
                        var variation_array = {
                            tier_index:[],
                            stock:value.available_quantity,
                            price:parseFloat(value.retail_price),
                            variation_sku:value.stock_no
                        }
                        if (index!=0){
                            variation_array.variation_sku = value.stock_no+'-'+index
                        }
                        var temp_variation_array = {
                            stock:value.available_quantity,
                            price:parseFloat(value.retail_price),
                            variation_sku:value.stock_no
                        }
                        switch (tier_count) {
                            case 1:
                            case 2:
                                if (color_status == true){
                                    if(index == 0){
                                        this.shopeeTemplate.tier_variation.push({name:"Color",options:[]})
                                        var ind =  this.shopeeTemplate.tier_variation.findIndex(x => x.name === "Color")
                                        color_index = ind
                                    }
                                    var option_index = this.shopeeTemplate.tier_variation[color_index].options.findIndex(x => x === value.color_name)
                                    if (option_index<0){
                                        option_index = this.shopeeTemplate.tier_variation[color_index].options.push(value.color_name) - 1
                                    }
                                    variation_array.tier_index.push(option_index)
                                    color_index==0 ? temp_variation_array.option = value.color_name : temp_variation_array.option1 = value.color_name
                                }
                                if (design_status == true){
                                    if(index == 0){
                                        this.shopeeTemplate.tier_variation.push({name:"Design",options:[]})
                                        var ind =  this.shopeeTemplate.tier_variation.findIndex(x => x.name === "Design")
                                        design_index = ind
                                    }
                                    var option_index = this.shopeeTemplate.tier_variation[design_index].options.findIndex(x => x === value.design_name)
                                    if (option_index<0){
                                        option_index = this.shopeeTemplate.tier_variation[design_index].options.push(value.design_name) - 1
                                    }
                                    variation_array.tier_index.push(option_index)
                                    design_index==0 ? temp_variation_array.option = value.design_name : temp_variation_array.option1 = value.design_name
                                }
                                if (size_status == true){
                                    if(index == 0){
                                        this.shopeeTemplate.tier_variation.push({name:"Size",options:[]})
                                        var ind =  this.shopeeTemplate.tier_variation.findIndex(x => x.name === "Size")
                                        size_index = ind
                                    }
                                    var option_index = this.shopeeTemplate.tier_variation[size_index].options.findIndex(x => x === value.size_name)
                                    if (option_index<0){
                                        option_index = this.shopeeTemplate.tier_variation[size_index].options.push(value.size_name) - 1
                                    }
                                    variation_array.tier_index.push(option_index)
                                    size_index==0 ? temp_variation_array.option = value.size_name : temp_variation_array.option1 = value.size_name
                                }
                            break;
                            case 3:
                                if (index == 0){
                                    this.shopeeTemplate.tier_variation.push({name:"Color",options:[]})
                                    var ind =  this.shopeeTemplate.tier_variation.findIndex(x => x.name === "Color")
                                    color_index = ind
                                    this.shopeeTemplate.tier_variation.push({name:"Size+Design",options:[]})
                                }
                                if (color_index==0){
                                    temp_variation_array.option = value.color_name
                                    temp_variation_array.option1 = value.size_name+'+'+value.design_name
                                }else {
                                    temp_variation_array.option1 = value.color_name
                                    temp_variation_array.option = value.size_name+'+'+value.design_name
                                }
                                var option_index = this.shopeeTemplate.tier_variation[color_index].options.findIndex(x => x === value.color_name)
                                if (option_index<0){
                                    option_index = this.shopeeTemplate.tier_variation[color_index].options.push(value.color_name) - 1
                                }
                                variation_array.tier_index.push(option_index)
                                var search_name = value.size_name+'+'+value.design_name
                                var option1_index = this.shopeeTemplate.tier_variation[color_index+1].options.findIndex(x => x === search_name)
                                if (option1_index<0){
                                    option1_index = this.shopeeTemplate.tier_variation[color_index+1].options.push(search_name) - 1
                                }
                                variation_array.tier_index.push(option1_index)
                            break;
                            default:
                            break;
                        }
                        this.shopeeTemplate.variation.push(variation_array)
                        this.shopeeTemplate.temp_variation.push(temp_variation_array)
                    })
                }
            },
            validation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Category', this.shopeeTemplate.category_id));
                this.errors.push(ValidateField.required('Product Name', this.shopeeTemplate.name));
                this.errors.push(ValidateField.charMinAndMax('Product Name', this.shopeeTemplate.name,20,255));

                this.errors.push(ValidateField.required('Logistics', this.shopeeTemplate.logistics.length));
                this.errors.push(ValidateField.required('Description', this.shopeeTemplate.description));
                this.shopeeTemplate.attributes.forEach((value, index) => {
                    if (value.is_mandatory){
                        this.errors.push(ValidateField.required(value.attribute_name, this.shopeeTemplate.attribute_values[`${value.attribute_id}`]));
                    }
                })
                if (this.productDetails.product_type == 'M'){
                    this.shopeeTemplate.variation.forEach((value, index) => {
                        for (const name in value) {
                            if (name!='stock'){
                                this.errors.push(ValidateField.required(name + " for row number " +(index+1), value[name]));
                            }
                        }
                    })
                }else {
                    this.errors.push(ValidateField.required('Parent SKU', this.shopeeTemplate.item_sku));
                    this.errors.push(ValidateField.required('Price', this.shopeeTemplate.price));
                }
                this.errors.push(ValidateField.required('Package Weight', this.shopeeTemplate.weight));
                this.errors.push(ValidateField.required('Package Weight', this.shopeeTemplate.weight));
                this.errors.push(ValidateField.required('Package Length', this.shopeeTemplate.package_length));
                this.errors.push(ValidateField.greaterThanZero('Package Length', this.shopeeTemplate.package_length));
                this.errors.push(ValidateField.required('Package Height', this.shopeeTemplate.package_height));
                this.errors.push(ValidateField.greaterThanZero('Package Height', this.shopeeTemplate.package_height));
                this.errors.push(ValidateField.required('Package Width', this.shopeeTemplate.package_width));
                this.errors.push(ValidateField.greaterThanZero('Package Width', this.shopeeTemplate.package_width));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            intToString(value){
                return value.toString()
            },
            async saveParams(){
                if(!this.validation()){
                    this.saveLoading = true
                    this.productDetails.shopeeParams = this.shopeeTemplate
                    this.productDetails.image_url = this.imageUrl +"/" +this.productDetails.filename
                    if (this.salesChannelId > 0){
                        var post_request =  await HTTPRequest.postRequest(this.endPoint+ 'shopee_integrations', null, {sales_channel_id:this.salesChannelId,product_details:this.productDetails})
                        console.log(post_request)
                        if (post_request["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "successfully Created."
                            });
                            this.$emit('getPostedProductData', null)
                            this.$emit('allProductsData', null)
                            this.$emit('closeProductFrom', null)
                        }else {
                            component_x.errors.push(post_request["error"])
                        }
                    } else {
                        this.$emit('integrationAddProduct', this.productDetails)
                    }
                    this.saveLoading = false
                }
            },
            async updateParams(){
                if(!this.validation()){
                    this.saveLoading = true
                    this.productDetails.shopeeParams = this.shopeeTemplate
                    this.productDetails.image_url = this.imageUrl +"/" +this.productDetails.filename
                    if (this.salesChannelId > 0){
                        var post_request =  await HTTPRequest.putRequest(this.endPoint+ 'shopee_integrations/'+this.salesChannelId, null, {product_details:this.productDetails})
                        console.log(post_request)
                        if (post_request["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "successfully Updated."
                            });
                            this.$emit('getPostedProductData', null)
                            this.$emit('allProductsData', null)
                            this.$emit('closeProductFrom', null)
                        }else {
                            component_x.errors.push(post_request["error"])
                        }
                    } else {
                        this.$emit('integrationUpdateProduct', this.productDetails)
                    }
                    this.saveLoading = false
                }
            },
            getParentCategory(category_id){
                var parent_index = this.tempCategories.findIndex(x => x.category_id == category_id)
                if(parent_index >=0){
                    if (this.tempCascaderCategory.length<=0){
                        this.tempCascaderCategory.push(category_id)
                    }
                    if(this.tempCategories[parent_index].parent_id!=0){
                        this.tempCascaderCategory.unshift(this.tempCategories[parent_index].parent_id)
                        this.getParentCategory(this.tempCategories[parent_index].parent_id)
                    }else{
                        this.shopeeTemplate.cascader_category = this.tempCascaderCategory
                        console.log(this.tempCascaderCategory)
                    }
                }
            }
        }
    };
</script>